// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"DialogInspectionCreate_dialogContent__9RVuP","errorMessage":"DialogInspectionCreate_errorMessage__K4kyA"};